import { ContentCopy } from '@mui/icons-material'
import { Alert, IconButton, Stack, Tooltip, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface SecretRowProps {
  label: string
  value: string
  copyLabel: string
}

const SecretRow: React.FC<SecretRowProps> = ({ label, value, copyLabel }) => (
  <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1}>
    <Typography variant="body2" fontWeight={500} color="text.secondary" sx={{ minWidth: '60px' }}>
      {label}
    </Typography>
    <Stack direction="row" spacing={1} alignItems="center" sx={{ flex: 1, minWidth: 0 }}>
      <Typography
        variant="body2"
        sx={{
          fontFamily: 'monospace',
          bgcolor: 'action.hover',
          px: 1,
          py: 0.5,
          borderRadius: 1,
          flex: 1,
          minWidth: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
        title={value}
      >
        {value}
      </Typography>
      <Tooltip title={copyLabel}>
        <IconButton size="small" onClick={() => navigator.clipboard.writeText(value)}>
          <ContentCopy fontSize="small" />
        </IconButton>
      </Tooltip>
    </Stack>
  </Stack>
)

interface IssuedSecretBannerProps {
  issuedSecret: { key: string; secret: string }
  onClose: () => void
}

export const IssuedSecretBanner: React.FC<IssuedSecretBannerProps> = ({ issuedSecret, onClose }) => {
  const { t } = useTranslation(['api-access'])

  return (
    <Alert severity="warning" onClose={onClose} sx={{ '& .MuiAlert-message': { width: '100%', p: 0 } }}>
      <Stack spacing={2} sx={{ width: '100%' }}>
        <Typography variant="subtitle2" fontWeight={600}>
          {t('copy-now')}
        </Typography>
        <Stack spacing={1.5}>
          <SecretRow label={t('key-label')} value={issuedSecret.key} copyLabel={t('copy')} />
          <SecretRow label={t('secret-label')} value={issuedSecret.secret} copyLabel={t('copy')} />
        </Stack>
      </Stack>
    </Alert>
  )
}
